<template>
	<div class="row">
		<div class="col-12">
			<div class="row">
				<div class="col-12 titulo-paso">CSV Invoiceables (Obligatorio)</div>
			</div>
			<div class="row">
				<div class="col-12 text-right">
					<b-button id="seguir" variant="success" v-on:click="seguir" :disabled="!disabled">SEGUIR</b-button>
					<hr/>
				</div>
			</div>
			<div class="row">
				<div class="col-12">
					<label class="control-label">A continuación: sube el archivo con la planilla completa</label>
					<upload-excel type="csv" :on-success="onSuccess" :before-upload="beforeUpload" />
				</div>
			</div>
			<p></p>
			<div v-if="error" class="row">
				<div class="col-12 text-center">
					<div class="row">&nbsp;</div>
					<div class="row">
						<div class="col-12">
							<h5><i class="fas fa-exclamation fa-fw" /> {{ mensaje }}</h5>
						</div>
					</div>
				</div>
			</div>
			<div v-if="validacion" class="row">
				<div class="col-8 offset-2">
					<b-progress max=100 variant="success">
						<b-progress-bar :value="avance">{{ avance }}%</b-progress-bar>
					</b-progress>
				</div>
			</div>
		</div>
	</div>
</template>
<script lang="ts">

	import axios from "axios"
	import UploadExcel from "./upload_excel.vue"


	export default
	{
		name: "Paso6",
		components: { UploadExcel },
		props: {
			periodo: String, 
			confirmacion: false,
			onAvanzar: Function, // Funcion callback para avanzar en el wizard
			onArchivo: Function, // Funcion callback para informar sobre el archivo cargado
		},
		data() {
			return {
				nombre: "invoiceable", // Tipo de archivo a cargar
				formato: [ "sale_code","sale_date","issuer_name","client_id","client_name","client_type","company_id","company_name","region","slug","client_tax_code","client_address","client_city","client_country","client_post_code","client_payment_term","client_payment_term_(sale)","billing_period","journey_id","invoice_code","invoice_date","skip_invoicing","sale_description","n_km","sale_rectify_code","sale_rectify_date","sale_rectify_tax_region_state","payment_method_rider","district","cost","price","discount","neto","base_imponible","iva.","total" ],
				disabled: false, // Flag que controla el boton SEGUIR
				validacion: false,
				avance: 0,
				error: false, // Flag que controla cuando mostrar el mensaje de error
				mensaje: "",
			}
		},
		methods: {

			// Se ejecuta antes de comenzar a leer el archivo
			// Sirve para activar el icono de espera
			beforeUpload() {

				this.error = false
				// Activamos la imagen cargando
				window.event.$emit("mostrar-cargando", true)

				return true
			},

			// Se ejecuta una vez que se leyo todo el archivo
			// Desactiva el icono de espera y muestra los datos leidos en la tabla
			onSuccess(header, data, file) {

				// Ocultamos la imagen cargando
				window.event.$emit("mostrar-cargando", false)

				if (header.join() == this.formato.join()) {

					this.validacion = true
					this.procesar(file) // Enviamos el archivo al servidor

					// Llamamos a la funcion callback para enviar la info del archivo cargado
					if (this.onArchivo)
						this.onArchivo({ archivo: this.nombre, nombre: file.name, tipo: file.type, tamanio: file.size, registros: data.length, avance: 0 })

				} else {

					this.mensaje = "El formato del archivo no corresponde"
					this.error = true
					this.validacion = false 
				}
			},

			procesar(file) {

				var request = new FormData()
				request.append("archivo", file)

				var header = {
					"Content-Type": file.type,
					"usuario": this.$usuario,
					"destino": this.$env,
					"proceso": "upDataFac",
					"archivo": this.nombre,
					"periodo": this.periodo,
				}

				// Variable para usar en la funcion del callback del evento UploadProgress, para poder actualizar el avance en la barra de progreso
				var that = this

				axios.post("/faceZip", request, { 
					headers: header, 
					onUploadProgress: function(event) { that.avance = parseInt(Math.round((event.loaded / event.total) * 100)) }
				}).then (response => {

					if (response.data.estatus == "OK")
						this.disabled = true // Activamos el boton SEGUIR cuando finaliza la subida del archivo
					else {

						this.mensaje = response.data.estatus
						this.error = true
					}

				}).catch(ex => {

					//console.log(ex.message)
					this.mensaje = ex.message
					this.error = true
				})
			},

			seguir() {

				// Funcion callback para avanzar al siguiente paso
				if (this.onAvanzar)
					this.onAvanzar()
			}
		}
	}

</script>
<style scoped>
</style>
